import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { BrandProvider } from "./context/BrandContext";
import { AuthProvider } from "./context/AuthContext";

import Home from "./pages/Home";
import About from "./pages/About";
import Activities from "./pages/Activities";
import Initiatives from "./pages/Initiatives";
import ElderCare from "./pages/ElderCare";
import Projects from "./pages/Projects";
import Gallery from "./pages/Gallery";
import News from "./pages/News";
import Contact from "./pages/Contact";
import Support from "./pages/Support";
import LegalPage from "./pages/LegalPage";
import Layout from "./components/site/Layout";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import Submissions from "./pages/admin/Submissions";
import ResourceManager from "./pages/admin/ResourceManager";
import ContentEditor from "./pages/admin/ContentEditor";
import Settings from "./pages/admin/Settings";
import Branding from "./pages/admin/Branding";
import Users from "./pages/admin/Users";
import Profile from "./pages/admin/Profile";
import LegalManager from "./pages/admin/LegalManager";

const Wrap = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <BrandProvider>
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors />
        <Routes>
          <Route path="/" element={<Wrap><Home /></Wrap>} />
          <Route path="/about" element={<About />} />
          <Route path="/activities" element={<Activities />} />
          <Route path="/initiatives" element={<Initiatives />} />
          <Route path="/elder-care" element={<ElderCare />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/news" element={<News />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/support" element={<Support />} />
          <Route path="/privacy" element={<LegalPage slug="privacy" />} />
          <Route path="/terms" element={<LegalPage slug="terms" />} />
          <Route path="/disclaimer" element={<LegalPage slug="disclaimer" />} />
          <Route path="/cookie-policy" element={<LegalPage slug="cookie" />} />
          <Route path="/donation-policy" element={<LegalPage slug="donation" />} />

          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/interest" element={<Submissions kind="interest" />} />
          <Route path="/admin/contact" element={<Submissions kind="contact" />} />
          <Route path="/admin/activities" element={<ResourceManager collection="activities" />} />
          <Route path="/admin/initiatives" element={<ResourceManager collection="initiatives" />} />
          <Route path="/admin/projects" element={<ResourceManager collection="projects" />} />
          <Route path="/admin/news" element={<ResourceManager collection="news" />} />
          <Route path="/admin/events" element={<ResourceManager collection="events" />} />
          <Route path="/admin/gallery" element={<ResourceManager collection="gallery" />} />
          <Route path="/admin/leadership" element={<ResourceManager collection="leadership" />} />
          <Route path="/admin/content" element={<ContentEditor />} />
          <Route path="/admin/settings" element={<Settings />} />
          <Route path="/admin/branding" element={<Branding />} />
          <Route path="/admin/users" element={<Users />} />
          <Route path="/admin/profile" element={<Profile />} />
          <Route path="/admin/legal" element={<LegalManager />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </BrandProvider>
  );
}

export default App;
